import React from 'react';
import { ClipboardList, Mail, CheckCircle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    icon: <ClipboardList className="w-10 h-10 text-orange-500" data-id="element-63" />,
    title: 'Fill out the form',
    description: '(takes 30 seconds)'
  }, {
    icon: <Mail className="w-10 h-10 text-orange-500" data-id="element-64" />,
    title: 'Receive quotes',
    description: 'from local companies'
  }, {
    icon: <CheckCircle className="w-10 h-10 text-orange-500" data-id="element-65" />,
    title: 'Compare and choose',
    description: 'the best option'
  }];
  return <section className="py-20 px-4 max-w-7xl mx-auto" data-id="element-66">
      <FadeIn data-id="element-67">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-68">
          How It Works
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-69">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gray-200 -z-10" data-id="element-70"></div>

        {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="flex flex-col items-center text-center relative bg-white" data-id="element-71">
            <div className="w-24 h-24 rounded-full bg-orange-50 flex items-center justify-center mb-6 shadow-sm border-4 border-white" data-id="element-72">
              {step.icon}
            </div>
            <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gray-900 text-white font-bold text-sm mb-4" data-id="element-73">
              {index + 1}
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-74">
              {step.title}
            </h3>
            <p className="text-gray-500 font-medium" data-id="element-75">{step.description}</p>
          </FadeIn>)}
      </div>
    </section>;
}